const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  variantChange: "variant-change",
  cartError: "cart-error",
};

/* Dynsol UI helpers (29 Sep 2026 design audit, batch 1)
   - hide the cart bubble when the cart is empty
   - load cart-drawer images straight away
   - homepage product grids: "Sale" badge shows the real discount (e.g. -24%)
   - homepage category rows: "Shop Now" -> "Shop now" */
(function () {
  var queued = false;
  function num(el) { return el ? parseInt(el.textContent.replace(/[^0-9]/g, ''), 10) || 0 : 0; }
  function run() {
    queued = false;
    document.querySelectorAll('.cart-count-bubble').forEach(function (b) {
      var s = b.querySelector('[aria-hidden="true"]');
      b.classList.toggle('dx-empty', !(s && parseInt(s.textContent, 10) > 0));
    });
    document.querySelectorAll('#cart-notification-product img[loading="lazy"]').forEach(function (i) {
      i.loading = 'eager';
    });
    document.querySelectorAll('[class^="anker-product-badge-"]').forEach(function (b) {
      if (b.dataset.dx || b.textContent.trim().toLowerCase() !== 'sale') return;
      var card = b.closest('[class^="anker-product-card-"]');
      if (!card) return;
      var now = num(card.querySelector('[class^="anker-product-price-current-"]'));
      var was = num(card.querySelector('[class^="anker-product-price-compare-"]'));
      if (now && was > now) { b.textContent = '−' + Math.round((was - now) * 100 / was) + '%'; b.dataset.dx = '1'; }
    });
    document.querySelectorAll('main a, main button').forEach(function (a) {
      if (a.dataset.dxc) return;
      a.dataset.dxc = '1';
      a.childNodes.forEach(function (n) {
        if (n.nodeType === 3 && /Shop Now/.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace('Shop Now', 'Shop now');
      });
    });
  }
  function queue() { if (!queued) { queued = true; requestAnimationFrame(run); } }
  document.addEventListener('DOMContentLoaded', function () {
    run();
    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true, characterData: true });
  });
})();
